import { Outlet } from "react-router-dom";

const AdminLayout: React.FC = () => {
  return <Outlet />;
};

export default AdminLayout;
